import React from 'react';
import styles from '../OrderStatus.module.css';

const HelpfulInfo = () => {
  return (
    <>
      <h2 className={styles.heading}>Other Helpful Customer Information</h2>
      <ul>
        <li><a href='/tutorials/adjusting-your-treadbelt.php'>Tutorial: Adjusting Your Treadbelt</a></li>
      </ul>
    </>
  );
};

export default HelpfulInfo;